import {
    GET_REPORT_ROUTE_COST_LOADING,
    GET_REPORT_ROUTE_COST_SUCCESS,
    GET_REPORT_ROUTE_COST_REJECT,
} from "../../actions/routeCost/getAll";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
}

const routeCostReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_REPORT_ROUTE_COST_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_REPORT_ROUTE_COST_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_REPORT_ROUTE_COST_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        default: return state;
    }
}

export default routeCostReducer